module.exports = __webpack_public_path__ + "img/reset_password.9254cc0c.svg";